<template>
	<div class="meeting-index max-content">
		<van-swipe @change="onChange" 
		class="swiper" 
		:show-indicators="false" 
		ref="swiper"
		:lazy-render="true">
			<van-swipe-item v-for="(value,index) in recommends" :key="index">
				<meeting-detail :meeting_id="value"></meeting-detail>
			</van-swipe-item>
		</van-swipe>
		<van-button class="pre-button" icon="arrow-left"  round @click="preTap" v-if="current!=0"></van-button>
		<van-button class="next-button" icon="arrow" round @click="nextTap" v-if="current!=recommends.length-1"></van-button>
		<van-button class="back-button" icon="wap-home-o" round @click="backHome" v-if="current!=0">首页</van-button>
		<tabbar :active="index"></tabbar>
	</div>
</template>
<script> 
    import MeetingDetail from './Details.vue'
	import Tabbar from '../components/Tabbar'
	import {VascularRecommend,MeetingsDetails} from '../../../config/interface.js'
	export default{
		components:{
			MeetingDetail,
			Tabbar,
		},
		data(){
			return{
				type:2,		//1:专栏模块; 2:会议模块; 3:前沿资讯模块;4:病例模块;5:器械模块; 6:首页;7:文章推荐
				index:2,    //tabbar的index值
				userInfo:eval('(' +localStorage.getItem("userInfo")+ ')'),  //用户信息
				current:0,
				recommends:[],
				meeting_name:''
			}
		},
		mounted(){
			this.GetRecommendMeetings();
		},
		methods:{
			//获取推荐会议
			GetRecommendMeetings(){
				const url=VascularRecommend;
				const method='POST'
				fetch(url,{},method)
				.then((res)=>{
					if(res.code==0){
						this.recommends=res.data
						//设置vuex中的meeting_id
						if(this.$store.state.meeting_id){
							this.recommends.find((value,index) =>{
								if(value==this.$store.state.meeting_id){
									this.$refs.swiper.swipeTo(index);
									this.getMeetingDetails(this.$store.state.meeting_id);
								}
							})
						}
						else{
							this.$store.dispatch('selectedMeeting',this.recommends[0]);
							this.getMeetingDetails(this.recommends[0]);
						}
					}
				})				
			},
			//会议详情
			getMeetingDetails(id){
				const url=MeetingsDetails;
				const method='POST';
				let params={
					meeting_id:id
				}
				fetch(url,params,method)
				.then((res)=>{
					if(res.code==0){
						let data=res.data;
						document.title=data.name;
						this.meeting_name=data.name;
						// this.meeting_dates=data.meeting_dates;
						//微信浏览器  请求jsdk
						if(common.is_weixin()){
							common.wxShare(data.name,data.title,data.shareimg);
						}
					}
					this.$store.dispatch('isShowLoading',false);
				})
			},
			onChange(index){
				this.current=index;
				this.$store.dispatch('selectedMeeting',this.recommends[index]);
				this.getMeetingDetails(this.recommends[index]);
			},
			nextTap(){
      			this.$refs.swiper.next()
   			},
			preTap(){
      			this.$refs.swiper.prev()
   			},
			backHome(){
      			this.$refs.swiper.swipeTo(0)
   			}
		}
	}
</script>
<style lang="scss">
.meeting-index{
	overflow: hidden;
	.swiper{
		margin-bottom: 50px;
		.van-swipe-item{
			overflow: auto;
		}
	}
	.pre-button{
		position: fixed;
		top:50%;
		box-shadow: 0 0 2px 2px #ccc;
		background: transparent;
		border-radius:50% ;
		width:40px;
		height:40px;
	}
	.next-button{
		position: fixed;
		top:50%;
		// right:0;
		margin-left: 9.6rem;
		box-shadow: 0 0 2px 2px #ccc;
		background: transparent;
		border-radius:50% ;
		width:40px;
		height:40px;
	}
	.back-button{
		position: fixed;
		top:80%;
		// right:0;
		margin-left: 8.5rem;
		box-shadow: 0 0 2px 2px #ccc;
		background: transparent;
		
		
	}
	@media screen and (max-width: 580px) {
		.next-button {right: 0;margin-left: 0;}
		.back-button {right: 0;margin-left: 0;}
	}
	
}
</style>


// WEBPACK FOOTER //
// src/pages/VascularSystem/Index/Index.vue